import { render } from "./PersonalCenter.vue?vue&type=template&id=5810c4c6&scoped=true"
import script from "./PersonalCenter.vue?vue&type=script&lang=js"
export * from "./PersonalCenter.vue?vue&type=script&lang=js"

import "./PersonalCenter.vue?vue&type=style&index=0&id=5810c4c6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5810c4c6"]])

export default __exports__